import { useLocation, useNavigate } from 'react-router-dom';
import { Badge, Box, Text, Tab, TabList, TabPanel, TabPanels, Tabs, Flex, Button } from '@chakra-ui/react';

import ProductBundle from './ProductBundle';
import { LeftArrowIcon } from '@assets/icons/index';
import InputComp from '@components/formField/InputComp';
import { AppProvider } from '@pages/UploadMappingV2/context/AppContext';
import useGetProductBundle, { useGetProductSatuan } from '@pages/UploadMappingV2/hooks/query/useGetListProduct';
import { useFilterPBundle, useFilterPSatuan } from '@pages/UploadMappingV2/hooks/state/useFilter';
import { usePaginationPBundle, usePaginationPSatuan } from '@pages/UploadMappingV2/hooks/state/useAllMappingPagination';
import ProductSatuan from './ProductSatuan';

export default function AllMapping() {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { search, setSearch, sort, resetFilter } = useFilterPBundle();
    const { sort: sortSatuan } = useFilterPSatuan();
    const { page, limit, resetPagination } = usePaginationPBundle();
    const { page: pageSatuan, limit: limitSatuan, resetPagination: resetPaginationSatuan } = usePaginationPSatuan();

    const { data, isLoading } = useGetProductBundle({
        type: 'bundle',
        page: page,
        limit: limit,
        search: search,
        sort: `${sort?.key}.${sort?.direction}`,
    });

    const { data: dataSatuan, isLoading: isLoadingSatuan } = useGetProductSatuan({
        type: 'piece',
        page: pageSatuan,
        limit: limitSatuan,
        search: search,
        sort: `${sortSatuan?.key}.${sortSatuan?.direction}`,
    });

    const handleBack = () => {
        resetPagination();
        resetPaginationSatuan();
        resetFilter();
        navigate(-1);
    };

    const handleSearch = (value) => {
        if (value) {
            setSearch(value);
        } else {
            setSearch(null);
        }
    };

    return (
        <AppProvider>
            <Box bg={'semantic.100'} borderRadius={'8px'} p="20px">
                <Flex alignItems="center" mb={'24px'} gap={'4px'}>
                    <Button variant={'unstyled'} onClick={handleBack}>
                        <LeftArrowIcon />
                    </Button>
                    <Text fontSize={'24px'} fontWeight={600}>
                        Product Mapping
                    </Text>
                </Flex>

                <InputComp
                    isShowLabel={false}
                    placeholder="Cari nama produk"
                    width={'300px'}
                    onChange={handleSearch}
                    isRightElement
                />

                <Box m={5} />

                <Tabs defaultIndex={state}>
                    <TabList>
                        <Tab>Product Satuan</Tab>
                        <Tab>
                            Product Bundle
                            <Badge
                                rounded={'full'}
                                textTransform={'capitalize'}
                                color={'semantic.100'}
                                bg={'danger.500'}
                                p={'4px 6px'}
                                ml={'8px'}
                            >
                                Baru!
                            </Badge>
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel pb={'0'}>
                            <ProductSatuan data={dataSatuan} isLoading={isLoadingSatuan} />
                        </TabPanel>
                        <TabPanel pb={'0'}>
                            <ProductBundle data={data} isLoading={isLoading} />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </AppProvider>
    );
}
